/*
 * Selman Gold – live precious metal buy rates (gold, silver, platinum, palladium)
 * Basis: live price per gram of the pure metal (Theme settings › Gold rates, window.SG):
 *   source "api":    fetches cfg.api (JSON: gold / silver / platinum / palladium .price_int = € per gram,
 *                    gold.percentage_change = day change %) on load and every cfg.interval ms.
 *                    Until the first answer (or for metals the API lacks) cfg.spot / cfg.metals are used.
 *   source "manual": fixed prices cfg.spot (gold) and cfg.metals (optional demo movement when cfg.demo).
 * Alloys + pricing rules: window.SG.alloys from the "Gold rates & ticker" section (one block per alloy):
 *   price per gram = basis of its metal × multiplier (empty = fineness) + modifier €/g; fixed €/g replaces it
 * Markup hooks (server-rendered by Liquid, updated here):
 *   [data-sg-price="585"]   buying price per gram for an alloy (key of the alloy block)
 *   [data-sg-market="585"]  market value per gram (live price × fineness, no buying rule – price bar)
 *   [data-sg-live="w;k;m;metal"]  live product price (weight × (live price × multiplier + Kurs change))
 *   [data-sg-trend="arrow"|"text"|"badge"]   trend indicator (classes is-up / is-down / is-flat)
 *   [data-sg-time]          time of last update ("12:00:05 Uhr"; data-sg-time="short" → "12:00:05")
 *   [data-sg-flash]         element re-animated (class is-flash) on every update
 *   [data-sg-value="585:10"]          value of 10 g 585er gold
 *   [data-sg-total="333:5,585:10"]    sum of several items
 *   [data-sg-board]          rate board: rows [data-sg-row] rebuilt from the alloy blocks (name, karat, purity, badge, coin);
 *                            gold boards list the "show in boards" alloys from the highest fineness down; with [data-sg-tab="silber"] buttons
 *                            (metal tabs) the board lists every alloy of the selected metal in block order
 *   select[data-sg-metal-select] + select[data-sg-alloy-select] (same [data-row])   metal and alloy choice;
 *                            options rebuilt from the alloy blocks, changing the metal preselects its default alloy
 * Other components listen to the `sg:rates` event on document.
 */
(function () {
  'use strict';
  var cfg = window.SG || {};
  var locale = cfg.locale || 'de-DE';
  var METALS = [
    { id: 'gold', name: 'Gold', word: 'Feingold', api: 'gold' },
    { id: 'silber', name: 'Silber', word: 'Feinsilber', api: 'silver' },
    { id: 'platin', name: 'Platin', word: 'Feinplatin', api: 'platinum' },
    { id: 'palladium', name: 'Palladium', word: 'Feinpalladium', api: 'palladium' }
  ];
  var DEFAULTS = [['333', '8 K', '33,3 %', '8 K · 333er'], ['375', '9 K', '37,5 %', '9 K · 375er'], ['585', '14 K', '58,5 %', '14 K · 585er'],
    ['750', '18 K', '75 %', '18 K · 750er'], ['916', '22 K', '91,6 %', '22 K · 916er'], ['999', '24 K', '99,9 %', '24 K · 999er Feingold']];
  function num(v, fallback) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isNaN(n) ? fallback : n; }
  var ALLOYS = (Array.isArray(cfg.alloys) && cfg.alloys.length ? cfg.alloys : DEFAULTS.map(function (d) {
    return { id: d[0], metal: 'gold', fineness: Number(d[0]) / 1000, name: d[0] + 'er Gold', karat: d[1], purity: d[2], label: d[3], coin: d[0], board: true, ticker: true, preselect: d[0] === '585', multiplier: '', modifier: '0' };
  })).filter(function (a) { return a && a.id; });
  var BY_ID = {}; var FINENESS = { unknown: 0 }; var METAL = {};
  METALS.forEach(function (m) { METAL[m.id] = m; });
  ALLOYS.forEach(function (a) {
    a.id = String(a.id).trim(); a.metal = METAL[a.metal] ? a.metal : 'gold';
    a.fineness = Number(a.fineness) || num(a.id.replace(/\D/g, ''), 0) / 1000;
    BY_ID[a.id] = a; FINENESS[a.id] = a.fineness;
  });
  var USED = METALS.filter(function (m) { return ALLOYS.some(function (a) { return a.metal === m.id; }); });
  var metalsCfg = cfg.metals || {};
  function ofMetal(metal) { return ALLOYS.filter(function (a) { return a.metal === metal; }); }
  function defaultOf(metal) { var list = ofMetal(metal); return (list.filter(function (a) { return a.preselect; })[0] || list[0] || { id: 'unknown' }).id; }
  // coin color: gold boards use the block's color, the metal-tab board groups gold by fineness (like the design)
  function coinOf(a, grouped) {
    if (a.metal !== 'gold') return a.metal;
    if (!grouped) return a.coin || '585';
    return a.fineness > 0.9 ? '999' : a.fineness > 0.7 ? '750' : a.fineness > 0.5 ? '585' : '333';
  }
  // highest fineness first (24 K … 333er), like the Live-Kurse board
  function byFineness(list) { return list.slice().sort(function (x, y) { return y.fineness - x.fineness; }); }

  var Rates = {
    spot: num(cfg.spot, 116),
    spots: { gold: num(cfg.spot, 116), silber: num(metalsCfg.silber, 1.6), platin: num(metalsCfg.platin, 30), palladium: num(metalsCfg.palladium, 28) },
    live: cfg.source === 'api' && !!cfg.api,
    demo: cfg.source !== 'api' && cfg.demo === true,
    dayChange: null,
    dayChanges: {},
    flash: false,
    factor: 1,
    prevFactor: 1,
    tick: 0,
    now: new Date(),
    alloys: ALLOYS,
    metals: METALS,
    fineness: FINENESS,
    alloy: function (id) { return BY_ID[id]; },
    metal: function (id) { return METAL[id]; },
    ofMetal: ofMetal,
    defaultOf: defaultOf,
    perGram: function (id) {
      var a = BY_ID[id];
      if (!a && id === 'unknown') return 0;
      var spot = (this.spots[a ? a.metal : 'gold'] || 0) * this.factor;
      if (!a) return spot * num(id, 0) / 1000;
      if (a.fixed !== '' && a.fixed != null && !isNaN(num(a.fixed, NaN))) return num(a.fixed, 0);
      // buying rule of the gold-price-manager: live price × multiplier (empty = fineness) ± price change
      return Math.max(0, spot * num(a.multiplier, a.fineness) + num(a.modifier, 0));
    },
    // live product price: weight × (live price × multiplier + Kurs change)
    // spec "weight;kurs;multiplier;metal" from data-sg-live (snippets/live-price-attrs.liquid); 0 if incomplete
    productPrice: function (spec) {
      var p = String(spec || '').split(';');
      var metal = { silver: 'silber', silber: 'silber', platinum: 'platin', platin: 'platin', palladium: 'palladium' }[(p[3] || '').trim().toLowerCase()] || 'gold';
      var weight = num(p[0], NaN), kurs = num(p[1], NaN), multiplier = num(p[2], NaN);
      var spot = (this.spots[metal] || 0) * this.factor;
      if (isNaN(weight) || isNaN(kurs) || isNaN(multiplier) || !spot) return 0;
      return Math.max(0, weight * (spot * multiplier + kurs));
    },
    // market value per gram: live price of the pure metal × fineness, without the buying rule (price bar)
    marketPerGram: function (id) {
      var a = BY_ID[id];
      return (this.spots[a ? a.metal : 'gold'] || 0) * this.factor * (a ? a.fineness : num(id, 0) / 1000);
    },
    valueOf: function (id, grams) { return this.perGram(id) * (grams || 0); },
    format: function (n) { return n.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; },
    // metal: optional (silber, …) – live day change of that metal (gold if omitted)
    trend: function (metal) {
      if (this.live) {
        // metals without live data (fixed price) stay flat
        var change = !metal || metal === 'gold' ? this.dayChange : this.dayChanges[metal] != null ? this.dayChanges[metal] : null;
        if (change === null || change === 0) return 'flat';
        return change > 0 ? 'up' : 'down';
      }
      if (!this.tick) return 'flat';
      return this.factor >= this.prevFactor ? 'up' : 'down';
    },
    changePct: function (metal) {
      if (this.live) return Math.abs((!metal || metal === 'gold' ? this.dayChange : this.dayChanges[metal]) || 0);
      return this.tick ? Math.abs((this.factor / this.prevFactor - 1) * 100) : 0;
    }
  };
  window.SGRates = Rates;

  // rate boards: one row per alloy, cloned from the server-rendered rows
  function syncBoards() {
    document.querySelectorAll('[data-sg-board]').forEach(function (board) {
      var tabs = board.querySelectorAll('[data-sg-tab]');
      var alloys;
      if (tabs.length) {
        var active = board.getAttribute('data-sg-metal') || 'gold';
        tabs.forEach(function (tab) {
          var id = tab.getAttribute('data-sg-tab');
          tab.hidden = !USED.some(function (m) { return m.id === id; });
          tab.setAttribute('aria-selected', id === active ? 'true' : 'false');
          tab.classList.toggle('is-active', id === active);
        });
        alloys = ofMetal(active);
      } else {
        var list = board.getAttribute('data-sg-board').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
        alloys = list.length ? list.map(function (id) { return BY_ID[id]; }).filter(Boolean) : byFineness(ALLOYS.filter(function (a) { return a.board !== false; }));
      }
      var rows = board.querySelector('[data-sg-row]');
      if (!rows) return;
      var container = rows.parentElement;
      var template = rows.cloneNode(true);
      var existing = {};
      container.querySelectorAll('[data-sg-row]').forEach(function (r) { existing[r.getAttribute('data-sg-row')] = r; r.remove(); });
      alloys.forEach(function (a) {
        var row = existing[a.id] || template.cloneNode(true);
        row.setAttribute('data-sg-row', a.id);
        var set = function (sel, fn) { var el = row.querySelector(sel); if (el) fn(el); };
        set('[data-sg-karat]', function (el) { el.textContent = a.karat || ''; });
        set('[data-sg-name]', function (el) { el.textContent = (el.getAttribute('data-sg-name') === 'label' ? a.label : a.name) || a.name || a.id; });
        set('[data-sg-purity]', function (el) { el.textContent = (a.purity || (a.fineness * 100).toLocaleString(locale, { maximumFractionDigits: 1 }) + ' %') + ' ' + METAL[a.metal].word; });
        set('[data-sg-popular]', function (el) { el.hidden = !a.popular; });
        set('[data-sg-coin]', function (el) { el.className = el.className.replace(/coin--\S+/, 'coin--' + coinOf(a, tabs.length > 0)); });
        set('[data-sg-price]', function (el) { el.setAttribute('data-sg-price', a.id); });
        container.appendChild(row);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-sg-tab]');
    var board = tab && tab.closest('[data-sg-board]');
    if (!board) return;
    board.setAttribute('data-sg-metal', tab.getAttribute('data-sg-tab'));
    syncBoards();
    render();
  });

  // calculator selects: metal select + alloy options of that metal (+ "Weiß ich nicht")
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function fillAlloys(sel, metal, keep) {
    var current = keep ? sel.value : '';
    sel.innerHTML = ofMetal(metal).map(function (a) {
      return '<option value="' + esc(a.id) + '">' + esc(a.label || a.name || a.id) + '</option>';
    }).join('') + '<option value="unknown">Weiß ich nicht</option>';
    sel.value = (BY_ID[current] && BY_ID[current].metal === metal) || current === 'unknown' ? current : defaultOf(metal);
  }
  function syncSelects(root) {
    (root || document).querySelectorAll('select[data-sg-alloy-select]').forEach(function (sel) {
      var row = sel.closest('[data-row]') || sel.parentElement;
      var metalSel = row.querySelector('select[data-sg-metal-select]');
      var known = BY_ID[sel.value];
      var metal = known ? known.metal : (metalSel && METAL[metalSel.value] ? metalSel.value : 'gold');
      if (metalSel) {
        metalSel.innerHTML = USED.map(function (m) { return '<option value="' + m.id + '">' + m.name + '</option>'; }).join('');
        metalSel.value = metal;
      }
      fillAlloys(sel, metal, true);
    });
  }
  // capture phase: runs before the calculators read the row
  document.addEventListener('change', function (e) {
    var metalSel = e.target.closest && e.target.closest('select[data-sg-metal-select]');
    if (!metalSel) return;
    var row = metalSel.closest('[data-row]') || metalSel.parentElement;
    var sel = row.querySelector('select[data-sg-alloy-select]');
    if (sel) fillAlloys(sel, metalSel.value, false);
  }, true);
  Rates.syncSelects = syncSelects;
  // set a row's metal + alloy (prefill): metal = the alloy's metal, or the given one for "unknown"
  Rates.choose = function (row, alloy, metal) {
    var sel = row.querySelector('select[data-sg-alloy-select]');
    if (!sel) return;
    var a = BY_ID[alloy];
    var m = a ? a.metal : (METAL[metal] ? metal : 'gold');
    var metalSel = row.querySelector('select[data-sg-metal-select]');
    if (metalSel) metalSel.value = m;
    fillAlloys(sel, m, false);
    if (a || alloy === 'unknown') sel.value = alloy;
  };

  function pad(n) { return String(n).padStart(2, '0'); }

  function render() {
    var t = Rates.now;
    var time = pad(t.getHours()) + ':' + pad(t.getMinutes()) + ':' + pad(t.getSeconds()) + ' Uhr';

    document.querySelectorAll('[data-sg-price]').forEach(function (el) {
      el.textContent = Rates.format(Rates.perGram(el.getAttribute('data-sg-price')));
    });
    document.querySelectorAll('[data-sg-live]').forEach(function (el) {
      var price = Rates.productPrice(el.getAttribute('data-sg-live'));
      if (price > 0) el.textContent = Rates.format(price);
    });
    document.querySelectorAll('[data-sg-market]').forEach(function (el) {
      el.textContent = Rates.format(Rates.marketPerGram(el.getAttribute('data-sg-market')));
    });
    document.querySelectorAll('[data-sg-value]').forEach(function (el) {
      var p = el.getAttribute('data-sg-value').split(':');
      el.textContent = Rates.format(Rates.valueOf(p[0], parseFloat(p[1]) || 0));
    });
    document.querySelectorAll('[data-sg-total]').forEach(function (el) {
      var sum = el.getAttribute('data-sg-total').split(',').reduce(function (acc, item) {
        var p = item.split(':'); return acc + Rates.valueOf(p[0].trim(), parseFloat(p[1]) || 0);
      }, 0);
      el.textContent = Rates.format(sum);
    });
    document.querySelectorAll('[data-sg-time]').forEach(function (el) {
      el.textContent = el.getAttribute('data-sg-time') === 'short' ? time.replace(' Uhr', '') : time;
    });
    document.querySelectorAll('[data-sg-trend]').forEach(function (el) {
      var mode = el.getAttribute('data-sg-trend');
      // metal: of the row, else of the board's selected tab (rate board header), else gold
      var row = el.closest('[data-sg-row]');
      var a = row && BY_ID[row.getAttribute('data-sg-row')];
      var board = el.closest('[data-sg-board]');
      var metal = a ? a.metal : board && board.getAttribute('data-sg-metal');
      var trend = Rates.trend(metal);
      var pct = Rates.changePct(metal).toFixed(2).replace('.', ',');
      var arrow = trend === 'up' ? '▲' : trend === 'down' ? '▼' : '•';
      var text = trend === 'flat' ? 'live' : (trend === 'up' ? '+' : '−') + pct + ' %';
      el.textContent = mode === 'arrow' ? arrow : mode === 'text' ? text : arrow + ' ' + text;
      el.classList.toggle('is-up', trend === 'up');
      el.classList.toggle('is-down', trend === 'down');
      el.classList.toggle('is-flat', trend === 'flat');
    });
    if (Rates.flash) {
      Rates.flash = false;
      document.querySelectorAll('[data-sg-flash]').forEach(function (el) {
        el.classList.remove('is-flash');
        void el.offsetWidth; // restart animation
        el.classList.add('is-flash');
      });
    }
    document.dispatchEvent(new CustomEvent('sg:rates', { detail: Rates }));
  }

  function step() {
    Rates.prevFactor = Rates.factor;
    Rates.factor = Rates.factor * (1 + (Math.random() - 0.5) * 0.003);
    Rates.tick += 1;
    Rates.flash = true;
    Rates.now = new Date();
    render();
  }

  function fetchLive() {
    if (document.hidden) return;
    fetch(cfg.api, { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        var gold = data && data.gold;
        var spot = Number(gold && gold.price_int);
        if (!(spot > 0)) throw new Error('kein Goldkurs');
        METALS.forEach(function (m) {
          var p = Number(data[m.api] && data[m.api].price_int);
          if (!(p > 0)) return;
          if (Rates.tick && Math.abs(p - Rates.spots[m.id]) > 0.000001) Rates.flash = true;
          Rates.spots[m.id] = p;
          if (data[m.api].percentage_change != null) Rates.dayChanges[m.id] = Number(data[m.api].percentage_change) || 0;
        });
        Rates.spot = spot;
        Rates.dayChange = Number(gold.percentage_change) || 0;
        Rates.tick += 1;
        Rates.now = new Date();
        render();
      })
      .catch(function (err) { if (window.console) console.warn('Selman Gold: Live-Kurs nicht erreichbar –', err.message); });
  }

  function start() {
    syncBoards();
    syncSelects();
    render();
    var every = Number(cfg.interval) || 30000;
    if (Rates.live) {
      fetchLive();
      setInterval(fetchLive, every);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) fetchLive(); });
    } else if (Rates.demo) {
      setInterval(step, every);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
